import { useEffect } from 'react';
import useSWR from 'swr';
import { useNavigate } from 'react-router-dom';
import { Sidebar } from '../components/Sidebar';
import { PlansTable } from '../components/PlansTable';
import { getAdminToken, clearAdminToken } from '../utils/auth';
import { useAppContext } from '../context/AppContext';
import api from '../utils/apiClient';

const fetcher = (url) => api.get(url).then((res) => res.data);

export default function UsagePage() {
  const navigate = useNavigate();
  const token = typeof window !== 'undefined' ? getAdminToken() : null;
  const { selectedApp } = useAppContext();

  useEffect(() => {
    if (!token) navigate('/login', { replace: true });
  }, [token, navigate]);

  const usageKey = token
    ? selectedApp
      ? `/api/admin/apps/${selectedApp.slug}/usage`
      : '/api/admin/usage'
    : null;

  const { data: usageData } = useSWR(usageKey, fetcher);

  useEffect(() => {
    if (usageData?.success === false && usageData.message?.includes('token')) {
      clearAdminToken();
      navigate('/login', { replace: true });
    }
  }, [usageData, navigate]);

  const handleLogout = () => {
    clearAdminToken();
    navigate('/login', { replace: true });
  };

  return (
    <div className="min-h-screen bg-surface text-white flex">
      <Sidebar onLogout={handleLogout} />
      <main className="flex-1 p-6 overflow-y-auto">
        <header className="flex items-center justify-between mb-6">
          <div>
            <h1 className="text-2xl font-serif text-white">AI Usage</h1>
            <p className="text-xs text-muted mt-1">
              {selectedApp
                ? `Token consumption for ${selectedApp.name}`
                : 'Select an app from the sidebar or view global stats below'}
            </p>
          </div>
        </header>

        <section className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
          <div className="card">
            <p className="text-[10px] uppercase tracking-[0.08em] text-muted">Users</p>
            <p className="mt-1 text-xl font-semibold text-white">{Number(usageData?.summary?.users || 0).toLocaleString()}</p>
          </div>
          <div className="card">
            <p className="text-[10px] uppercase tracking-[0.08em] text-muted">Banned</p>
            <p className="mt-1 text-xl font-semibold text-white">{Number(usageData?.summary?.bannedUsers || 0).toLocaleString()}</p>
          </div>
          <div className="card">
            <p className="text-[10px] uppercase tracking-[0.08em] text-muted">Total Tokens</p>
            <p className="mt-1 text-xl font-semibold text-white">{Number(usageData?.summary?.totalTokens || 0).toLocaleString()}</p>
          </div>
          <div className="card">
            <p className="text-[10px] uppercase tracking-[0.08em] text-muted">Requests</p>
            <p className="mt-1 text-xl font-semibold text-white">{Number(usageData?.summary?.totalRequests || 0).toLocaleString()}</p>
          </div>
        </section>

        <section>
          <PlansTable plans={usageData?.topUsers || []} />
        </section>
      </main>
    </div>
  );
}
